import * as tslib_1 from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';
import showDiv from '@ivy/fts/showDiv';
import realGroup from '../../comps/realGroup.vue';
import SellDetail from '../../comps/sellDetail.vue';
let SnapshotAct = class SnapshotAct extends Vue {
    constructor() {
        super(...arguments);
        this.limitTime = [];
        this.show = false;
        this.typeMap = {
            presell: '预付定金',
            limit_buy: '限时折扣',
            group: '限时拼团',
            limit_free: '限时免费',
        };
    }
    mounted() {
        const msec = new Date(this.snapshotInfo.activity.end_time
            ? this.snapshotInfo.activity.end_time.replace(/-/g, '/')
            : this.snapshotInfo.activity.presell_end_time.replace(/-/g, '/')).getTime() -
            new Date(this.snapshotInfo.create_time.replace(/-/g, '/')).getTime();
        if (msec <= 0)
            return;
        this.snapshotTime = Date.formatMs(msec, 'DD hh mm ss');
        this.limitTime = this.snapshotTime.split(' ');
        this.show = true;
    }
    get discountTypeName() {
        let limitBuyType = this.snapshotInfo.activity.activity_name === '限时报名'
            ? '限时报名'
            : '限时折扣';
        let type = this.snapshotInfo.activity.type;
        return ((type === 'limit_buy' ? limitBuyType : this.typeMap[type]) || '限时折扣');
    }
    get limitTimeFilter() {
        return this.limitTime.splice(-3);
    }
    get getDay() {
        let day = this.limitTime[0];
        if (day === '00') {
            return '';
        }
        else {
            return Number(day) + '天';
        }
    }
    getPriceClass(type) {
        switch (type) {
            case 'limit_buy':
                return `limit_buy`;
            case 'group':
                return `group`;
            case 'presell':
                return `presell`;
            case 'limit_free':
                return `limit_free`;
        }
    }
    showRule() {
        this.$router.push({
            path: `/presellRule`,
            query: {
                ruleUrl: this.snapshotInfo.activity.rule_pic,
            },
        });
    }
    async showQr() {
        await showDiv(realGroup, {
            info: {
                qrcode: this.snapshotInfo.activity.front_official_account_qrcode ||
                    this.snapshotInfo.activity.qrcode,
            },
        });
    }
};
tslib_1.__decorate([
    Prop()
], SnapshotAct.prototype, "activity", void 0);
tslib_1.__decorate([
    Prop()
], SnapshotAct.prototype, "create_time", void 0);
tslib_1.__decorate([
    Prop()
], SnapshotAct.prototype, "snapshotInfo", void 0);
SnapshotAct = tslib_1.__decorate([
    Component({
        components: {
            SellDetail,
        },
    })
], SnapshotAct);
export default SnapshotAct;
